import React, { Component } from 'react';

class Policies extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: '//www.dcblox.com/terms-of-use',
		};
	}
	changeUrl = item => {
		const activeItem = document.getElementById(item.id);
		const currentlyActiveItem = document.querySelector('.policies-list-item.active');
		if (currentlyActiveItem) {
			currentlyActiveItem.classList.remove('active');
		}
		activeItem.classList.add('active');

		this.setState({ url: item.url });
	};

	getListItems = () => {
		const list = [
			{ name: 'Terms of use', url: '//www.dcblox.com/terms-of-use', id: 'terms_of_use' },
			{ name: 'Acceptable Use', url: '//www.dcblox.com/acceptable-use', id: 'acceptable_use' },
			{
				name: 'Shared Responsibility',
				url: '//www.dcblox.com/shared-responsibility',
				id: 'shared_responsilbilty',
			},
			{ name: 'Privacy Policy', url: '//www.dcblox.com/privacy-policy', id: 'privacy_policy' },
			{ name: 'Cookie Policy', url: '//www.dcblox.com/cookie-policy', id: 'cookie_policy' },
		];
		return list.map(item => (
			<div
				key={item.id}
				id={item.id}
				className={item.id === 'terms_of_use' ? 'policies-list-item active' : 'policies-list-item'}
				onClick={() => this.changeUrl(item)}
			>
				{item.name}
			</div>
		));
	};

	openUrl = url => {
		window.open(url);
	};

	render() {
		const { url } = this.state;
		return (
			<div className='policies-container'>
				<div className='header'>
					<div className='text footer70'>Terms/Policies</div>
					{/* <div className='notifications'>
						<div className='amount footer11'>6</div>
						<img src={notificationDiamond} />
					</div> */}
				</div>
				<div className='content'>
					<div className='list-container'>{this.getListItems()}</div>
					<div className='website-container' onClick={() => this.openUrl(url)}>
						<iframe src={url} title='terms-of-use' allowFullScreen></iframe>
					</div>
				</div>
				<div className='footer-section '>
					<div className='terms-section'>
						<div className='text footer50'>TERMS/POLICIES</div>
						{/* <div className='notifications'>
							<div className='amount footer11'>1</div>
							<img src={notificationDiamond} />
						</div> */}
					</div>

					<div className='eula-section'>
						<div className='text footer50'>EULA</div>
						{/* <div className='notifications'>
							<div className='amount footer11'>1</div>
							<img src={notificationDiamond} />
						</div> */}
					</div>
					<div className='release-notes-section'></div>
				</div>
			</div>
		);
	}
}
export default Policies;
